var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14.0 14.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9998,0 L13.9998,14 L0,14 L0,0 L13.9998,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.118,0 C7.761,0 9.182,0.592692986 10.342,1.7637972 C11.501,2.93388129 12.09,4.40184206 12.09,6.12789461 C12.09,6.74405048 12.004,7.33062271 11.835,7.87230942 C11.665,8.41603637 11.408,8.96690421 11.069,9.50961104 L11.045,9.54735569 L13.685,12.2404873 C13.894,12.4536936 14,12.692403 14,12.9504948 C14,13.2085865 13.894,13.4472959 13.683,13.6625424 C13.482,13.8890103 13.263,14.000204 13.013,14.000204 C13,14.000204 12.987,14.000204 12.974,13.9991839 C12.707,13.9879625 12.466,13.88595 12.258,13.6972267 L9.688,11.0377592 L9.65,11.068363 C9.118,11.4876346 8.548,11.7997931 7.958,11.9966773 C7.364,12.1945817 6.745,12.2935339 6.118,12.2935339 C4.451,12.2935339 2.999,11.6937 1.802,10.5103543 C0.607,9.32802868 0,7.85292703 0,6.12789461 C0,4.40286218 0.607,2.93490141 1.802,1.7637972 C2.998,0.592692986 4.451,0 6.118,0 Z M6.118,2.05963363 C4.982,2.05963363 4.011,2.45034174 3.232,3.21951646 C2.453,3.9897113 2.058,4.96801178 2.058,6.12789461 C2.058,7.31328058 2.453,8.30382256 3.232,9.0740174 C4.011,9.84319212 4.982,10.2328801 6.118,10.2328801 C7.255,10.2328801 8.209,9.84217199 8.951,9.07299727 C9.693,8.30280243 10.069,7.31124033 10.069,6.12789461 C10.069,4.9690319 9.693,3.99073143 8.951,3.22053659 C8.208,2.45034174 7.255,2.05963363 6.118,2.05963363 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.00019999999999953388 -0.00020402512423611796)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.0002,0.000204025124 14,0.000204025124 14,14.000204 0.0002,14.000204 0.0002,0.000204025124",
    stroke: "none",
    fill: "#FF7700"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.1a950fa0850cf276f1fdda4a7337c83b.svg";
export { ForwardRef as ReactComponent };